import React from "react"
import { loadUserLogin } from "../../../../service/userManagementAction"
import { formatterRowComponent } from "../../../../../component/atoms/Tabel"
import { Card, OverlayTrigger, Tooltip } from "react-bootstrap"
import { DetailSvgIcon, EditSvgIcon } from "../../../../../component/atoms/Icons/SVG"
import { CardBody } from "../../../../../_metronic/_partials/controls"
import { EmptyCard, TableSkeleton, TableView } from "../../../../../component"
import { linkWithCtrl } from "../../../../helpers/Utils"
import { RoutesConstants } from "../../../../../constants/RoutesConstants"
import { useTranslation } from "react-i18next"
import { PRIVILEGE_ENUM } from "../../../../../constants/PrivilegeConstants.js"
import { stringFormatting } from "../../../../helpers/TextHelper.js"

export const ListTeamDrone = ({ history, data, changePage, general, isActiveSearch }) => {
  const privileges = loadUserLogin().privilege
  const { t } = useTranslation()

  const uiAction = (e) => {
    return (
      <div>
        {privileges.indexOf(PRIVILEGE_ENUM.DETAIL_FARMER_REGISTERED) > -1 && (
          <OverlayTrigger overlay={<Tooltip id="products-edit-tooltip">Detail</Tooltip>}>
            <div
              onClick={() => {
                history.push(RoutesConstants.FIELD_OFFICER.DETAIL_FO_AGRONOMIST_TEAM(e?.id))
              }}
              className="btn btn-icon btn-detail btn-hover-secondary btn-sm mx-3">
              <DetailSvgIcon size="2x" />
            </div>
          </OverlayTrigger>
        )}
        {privileges.indexOf(PRIVILEGE_ENUM.UPDATE_FARMER) > -1 && (
          <OverlayTrigger overlay={<Tooltip id="products-edit-tooltip">Edit</Tooltip>}>
            <div
              onClick={() => {
                history.push(RoutesConstants.FIELD_OFFICER.EDIT_TEAM_DRONE("edit", e?.id))
              }}
              className="btn btn-icon btn-detail btn-hover-secondary btn-sm mx-3">
              <EditSvgIcon size="2x" />
            </div>
          </OverlayTrigger>
        )}
      </div>
    )
  }

  const uiDesc = (e) => {
    return <div>{e?.description.length ? e?.description : "-"}</div>
  }

  const colums = [
    {
      dataField: "team_name",
      text: t("label_team_name").toUpperCase(),
      formatter: formatterRowComponent,
      headerStyle: () => {
        return { width: "15%" }
      },
      formatExtraData: {
        externalStyle: (e) => {
          return <div>
            <div className="font-weight-bolder">{stringFormatting(e?.team_name)}</div>
            <div className="text-muted font-weight-bold d-block">{stringFormatting(e?.warehouse_code)}</div>
          </div>
        }
      }
    },
    {
      dataField: "team_member",
      text: t("label_team_member").toUpperCase(),
      formatter: formatterRowComponent
    },
    {
      dataField: "sub_regional_name",
      text: t("label_sub_regional").toUpperCase(),
      formatter: formatterRowComponent,
      formatExtraData: {
        externalStyle: (e) => {
          return (
            <div>
              <div>{stringFormatting(e?.sub_regional_name)}</div>
              {e?.regency_names && (
                <div className="text-muted font-weight-bold d-block">{e.regency_names}</div>
              )}
            </div>
          )
        }
      }
    },
    {
      dataField: "base_code",
      text: t("table_header_base_name").toUpperCase(),
      formatter: formatterRowComponent,
      formatExtraData: {
        externalStyle: (e) => {
          return (
            <>
              <span className={"font-weight-bolder"}>{stringFormatting(e?.base_code)}</span>
              <span className="text-muted font-weight-bold d-block">
                {stringFormatting(e?.base_address)}
              </span>
            </>
          )
        }
      }
    },
    {
      dataField: "description",
      text: t("label_description").toUpperCase(),
      formatter: formatterRowComponent,
      headerStyle: () => {
        return { width: "20%" }
      },
      formatExtraData: {
        externalStyle: uiDesc
      }
    },
    {
      dataField: "action",
      text: t("label_action").toUpperCase(),
      sort: false,
      formatter: formatterRowComponent,
      formatExtraData: {
        externalStyle: uiAction
      },
      headerStyle: () => {
        return { width: "15%" }
      }
    }
  ]

  return (
    <>
      <Card>
        <CardBody>
          <div className={"d-flex justify-content-end mb-10"}>
            <button
              className={"btn btn-primary"}
              onClick={() => history.push(RoutesConstants.FIELD_OFFICER.CREATE_TEAM("new"))}>
              Tambah Tim
            </button>
          </div>
          {general.loading ? (
            <TableSkeleton column={4} row={10} />
          ) : data?.pageData.length == 0 ? (
            <EmptyCard
              body={
                isActiveSearch
                  ? t("messages_response_data_not_found")
                  : t("messages_response_empty_state")
              }
            />
          ) : (
            ""
          )}
          <TableView
            callbackAfterPageChange={changePage}
            columnProperties={colums}
            dataTable={data?.listParam === "TEAM_DRONE" ? data?.pageData : []}
            currentPage={data?.page?.currentPage ?? 1}
            currentElement={data?.page?.currentElement ?? 10}
            totalCount={data?.page?.totalCount ?? 0}
            loadingGetData={general.loading}
            ignoreSinglePage
            rowClasses={() => {
              return "cursor-pointer"
            }}
            rowEvents={{
              onClick: (e, row) => {
                if (
                  privileges.indexOf(PRIVILEGE_ENUM.LIST_FIELD_OFFICER_AGRONOMIST_TAB_TEAM_DRONE)
                ) {
                  if (e.target.cellIndex < 3) {
                    const url = RoutesConstants.FIELD_OFFICER.DETAIL_FO_AGRONOMIST_TEAM(row?.id)
                    if (e.ctrlKey) {
                      linkWithCtrl(url)
                    } else {
                      history.push(url)
                    }
                  }
                }
              }
            }}
          />
        </CardBody>
      </Card>
    </>
  )
}